import { BUSCAR_VIAGENS, LIMPAR_VIAGENS, ALTERAR_VIAGEM_SELECIONADA } from '../../actions/types'

const initialState = undefined

export default function reducerBuscarViagens (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_VIAGENS: {
      if (action.payload.data) {
        const { datasIdaProximas, datasRetornoProximas } = action.payload.data;
        const dedup = (list) => list
          ? [...new Map(list.map(p => [`${p.idItinerario}_${p.tipoVeiculo}`, p])).values()]
          : [];
        return {
          ...state,
          passagensIda: dedup(action.payload.data.passagensIda)
            .map(passagemIda => Object.assign({}, passagemIda, { sentido: 'IDA' })),
          passagensRetorno: dedup(action.payload.data.passagensRetorno)
            .map(passagemRetorno => Object.assign({}, passagemRetorno, { sentido: 'VOLTA' })),
          datasIdaProximas,
          datasRetornoProximas
        }
      }

      return []
    }
    case ALTERAR_VIAGEM_SELECIONADA: {
      const viagem = action.payload;
      if (viagem.sentido === 'IDA') {
        const indice = state.passagensIda.indexOf(viagem);
        const novaIda = Object.assign({}, viagem, { selecionada: !viagem.selecionada });
        const idas = state.passagensIda.map(passagemIda => Object.assign({}, passagemIda, { selecionada: false }));
        idas[indice] = novaIda;
        return {
          ...state,
          passagensIda: idas

        }
      }
      if (viagem.sentido === 'VOLTA') {
        const indice = state.passagensRetorno.indexOf(viagem);
        const novaVolta = Object.assign({}, viagem, { selecionada: !viagem.selecionada });
        const voltas = state.passagensRetorno.map(passagemRetorno => Object.assign({}, passagemRetorno, { selecionada: false }));
        voltas[indice] = novaVolta;

        return {
          ...state,
          passagensRetorno: voltas

        }
      }
      return state;
    }
    case LIMPAR_VIAGENS: {
      return []
    }

    default: {
      return state
    }
  }
}
